// extracted by mini-css-extract-plugin
module.exports =  {"rssStyle":"RssDirective_rssStyle__3lpV4","muted":"RssDirective_muted__mdfYE"};